import { Component, OnInit } from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {MessageService} from "primeng/api";
import {DeleteOrderBillModel} from "../../../models/orders/delete-order-bill.model";
import {ManagerPinDialogComponent} from "../../manager-pin-dialog/manager-pin-dialog.component";
import {OrderService} from "../../../services/order/order.service";
import {TranslateService} from "@ngx-translate/core";
import {DeleteOrderBillItemModel} from "../../../models/orders/delete-order-bill-item.model";
import {Subject, takeUntil} from "rxjs";

@Component({
  selector: 'app-delete-order-bill',
  templateUrl: './delete-order-bill.component.html',
  styleUrls: ['./delete-order-bill.component.scss']
})
export class DeleteOrderBillComponent implements OnInit {

  public unsubscribe: Subject<void> = new Subject<void>();

  public orderBillToDelete: DeleteOrderBillModel;
  public orderBillItemToDelete: DeleteOrderBillItemModel;

  constructor(private config: DynamicDialogConfig,
              private ref: DynamicDialogRef,
              public dialogService: DialogService,
              public translate: TranslateService,
              public orderService: OrderService,
              private messageService: MessageService,
  ) {
    if (this.config.data.deleteOrderBill != undefined) {
      this.orderBillToDelete = new DeleteOrderBillModel();
      this.orderBillToDelete.orderBillId = this.config.data.deleteOrderBill.orderBillId;
      this.orderBillToDelete.venueId = this.config.data.deleteOrderBill.venueId;
    }
    if (this.config.data.deleteOrderBillItem != undefined) {
      this.orderBillItemToDelete = new DeleteOrderBillItemModel();
      this.orderBillItemToDelete.orderBillItemId = this.config.data.deleteOrderBillItem.orderBillItemId;
      this.orderBillItemToDelete.venueId = this.config.data.deleteOrderBillItem.venueId;
      this.orderBillItemToDelete.employeeId = this.config.data.deleteOrderBillItem.employeeId;
      this.orderBillItemToDelete.quantity = this.config.data.deleteOrderBillItem.quantity;
    }
  }

  ngOnInit(): void {
  }

  delete(){
    const ref = this.dialogService.open(ManagerPinDialogComponent, {
      data: {
        venueId : this.orderBillToDelete != undefined ? this.orderBillToDelete.venueId : this.orderBillItemToDelete.venueId,
        pinConfirmationOption: true
      },
      showHeader: false,
      width: '100%',
      height: '100%',
      styleClass: "manager_pin_delete"
    });

    ref.onClose.subscribe((response: any) => {
      if(response){

        if(this.orderBillToDelete){
          this.orderBillToDelete.managerPin = response;
          this.deleteOrderBill(this.orderBillToDelete);

        }else {
            this.orderBillItemToDelete.pin = response;
            this.deleteOrderBillItem(this.orderBillItemToDelete);
        }
      }
    });
  }

  deleteOrderBill(orderBillToDelete: DeleteOrderBillModel){
    this.orderService.deleteOrderBill(orderBillToDelete)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (response) => {
          this.ref.close(true);
        },
        (errorResponse) => {
          this.ref.close(false);
        });

  }
  deleteOrderBillItem(orderBillItemToDelete: DeleteOrderBillItemModel){
    this.orderService.deleteOrderBillItem(orderBillItemToDelete)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (response) => {
          this.ref.close(true);
        },
        (errorResponse) => {
          this.ref.close(false);
        });
  }

  cancel(): void {
    this.ref.close(null);
  }

}
